import { Router } from '@angular/router';
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/services/base.service";
import {
  HelpPageDto,
  HelpSortOrdersDto,
  HelpCategoryDto,
  
  HelpPageNewDto,
} from "src/app/models/help-new";


import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { convertObjectToFormData } from "src/app/helpers/convertToFormData";
import { SettingsService } from '../settings/settings.service';
import { CoreSetting } from 'src/app/pages/settings/settings.service';
import { NavigateAssociates } from 'src/app/helpers/navigate-associates';
import { ReturnFlag } from 'src/app/models/return-flag';
import { AddHelpCategoryDto, TreeOrderNodes } from './help.module';

@Injectable({
  providedIn: "root",
})
export class HelpService {
  [x: string]: any;
  constructor(
    private _settingsService: SettingsService,
    private _baseService: BaseService,
    private _router: Router,
    private _navigates: NavigateAssociates,
  ) { }

  GetCategories(): Observable<{
    categories: HelpCategoryDto[];
    pages: HelpPageDto[];
  }> {
    return this._baseService.get("help/GetCategories");
  }

  GetHelpPageDataNew(): Observable<{
    categories: HelpCategoryDto[];
    pages: HelpPageDto[];
  }> {
    return this._baseService.get("help/GetCategoriesNew");
  }

  GetCategoriesRecordNew(): Observable<{
    categories: Record<number, HelpCategoryDto>;
  }> {
    return this.GetHelpPageDataNew().pipe(
      map(({ categories }) => ({ 
        categories: categories.reduce((categoriesObj, category) => {
          categoriesObj[category.categoryId] = category;
          return categoriesObj;
        }, {}),
      }))
    );
  }

  GetCategoriesRecord(): Observable<{
    categories: Record<number, HelpCategoryDto>;
    pages: Record<number, HelpPageDto>;
  }> {
    return this.GetCategories().pipe(
      map(({ categories, pages }) => ({
        pages: pages.reduce((pagesObj, page) => {
          pagesObj[page.pageId] = page;
          return pagesObj;
        }, {}),
        categories: categories.reduce((categoriesObj, category) => {
          categoriesObj[category.categoryId] = category;
          return categoriesObj;
        }, {}),
      }))
    );
  }

  SavePage(page: HelpPageNewDto, files: File[] = []): Observable<HelpPageDto> {
    const formData = new FormData();
 
    convertObjectToFormData(formData, page);
    for (let file of files) {
      formData.append("files", file);
    }

    return this._baseService.postFormData("help/SavePage", formData);
  }

  SaveOrders(ordered: HelpSortOrdersDto): Observable<any> {
    return this._baseService.post("help/SaveSortOrder", ordered);
  }

  UpdateOrders(trees: TreeOrderNodes[]): Observable<any> {
    return this._baseService.post("help/UpdateSortOrder", trees);
  }

  SaveCategory(category: HelpCategoryDto): Observable<HelpCategoryDto> {
    return this._baseService.post("help/SaveCategory", category);
  }
  TestSaveCategory(category: AddHelpCategoryDto): Observable<AddHelpCategoryDto> {
    return this._baseService.post("help/SaveCategory", category);
  }
  public async openHelpPage(settingName: string) {
    const coreSetting: CoreSetting = await this._settingsService.getCoreSetting(null, settingName);

   



    this._navigates.navigateTO(`/help`, `?id=${coreSetting.value}`);
  }

  public openHelpPageById(id: number = null) {
    if (id) {
      this._navigates.navigateTO(`/help`, `?id=${id}`);
    } else {
      this._navigates.navigateTO(`/help`);
    }
  }

  DeleteHelpSection(helpid: number): Observable<ReturnFlag> {
    return this._baseService.post("help/DeleteHelpSection?id="+helpid );
  }

  GetCategory(): Observable<any> {
    return this._baseService.post("help/GetCategory");
  }

  GetPageDetails(pageid: number): Observable<any> {
    return this._baseService.post("help/GetPageDetails",+pageid);
  }

  
}


